import { Feedback } from '@/modules/feedbacks/domain/feedback';
import { FeedbacksResults } from '@/modules/feedbacks/domain/feedbacks-results';
import { FeedbacksState } from '@/modules/feedbacks/store/feedbacks.states';
import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';

class FeedbacksRepository extends HttpRepository {
    private static readonly RESOURCE = 'feedbacks';

    /**
     * Crea una opinión o valoración para el usuario actual
     * @param feedback: opinión o valoración del usuario
     * @return Feedback
     */
    async createFeedback(feedback: Feedback): Promise<Feedback> {
        return (
            await this.post(
                this.createUri([`${FeedbacksRepository.RESOURCE}`]),
                feedback,
                this.createAuthorizationHeader(),
            )
        ).data;
    }

    /**
     * Permite obtener todas las métricas que son visualizadas desde el dashboard de feedbacks
     */
    async getFeedbackDashboard(
        limit: number = 10,
        start: number = 1,
        type?: number,
        rating?: number,
    ): Promise<FeedbacksState> {
        return (
            await this.get(
                this.createUri(['views', `${FeedbacksRepository.RESOURCE}`], {
                    limit,
                    start,
                    type,
                    rating,
                }),
                this.createAuthorizationHeader(),
            )
        ).data.values;
    }

    /**
     * Permite obtener todas las sugerencias del mes en curso que se encuentran registradas en el portal
     * @param limit number
     * @param start number
     * @returns Promise<FeedbacksResults>
     */
    async getMonthSuggestions(limit: number = 5, start: number = 1): Promise<FeedbacksResults> {
        const result = await this.get(
            this.createUri(['views', `${FeedbacksRepository.RESOURCE}`, 'month-suggestions'], {
                limit,
                start,
            }),
            this.createAuthorizationHeader(),
        );

        return result.data;
    }
}

export default new FeedbacksRepository();
